/*
 * Copyright (c) 2024-2026. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import React from 'react'
import clsx from 'clsx'

interface UiPillProps {
    children: React.ReactNode
    className?: string
}

const UiPill = (props: UiPillProps) => {
    return (
        <span
            className={clsx(
                'UiPill inline-flex items-center px-2 py-1 text-xs font-medium rounded-full whitespace-nowrap',
                props.className
            )}
        >
            {props.children}
        </span>
    )
}

export default UiPill
